import _typeof from "/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/typeof";
import { __assign, __awaiter, __generator, __rest } from "tslib";
import { createInstance as createBaseInstance } from '@amplitude/analytics-browser';
import { returnWrapper } from '@amplitude/analytics-core';
import { webAttributionPlugin } from '@amplitude/plugin-web-attribution-browser';
import { context } from './plugins/context';
export var createInstance = function createInstance() {
  var client = createBaseInstance();
  var _init = function _init(options) {
    return __awaiter(void 0, void 0, void 0, function () {
      var attribution, pageViewTracking, apiKey, userId, restOfOptions, browserOptions;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            attribution = options.attribution, pageViewTracking = options.pageViewTracking, apiKey = options.apiKey, userId = options.userId, restOfOptions = __rest(options, ["attribution", "pageViewTracking", "apiKey", "userId"]);
            browserOptions = restOfOptions;
            if (!!(attribution === null || attribution === void 0 ? void 0 : attribution.disabled)) return [3 /*break*/, 2];
            // Install web attribution plugin
            return [4 /*yield*/, client.add(webAttributionPlugin(client, attribution)).promise];
          case 1:
            // Install web attribution plugin
            _a.sent();
            _a.label = 2;
          case 2:
            // Transform config to disable web attribution plugin in browser SDK
            // Browser SDK has a slightly different implementation of web attribution
            browserOptions.attribution = {
              disabled: true
            };
            return [4 /*yield*/, client.add(context()).promise];
          case 3:
            _a.sent();
            delete browserOptions.defaultTracking;
            if (pageViewTracking === true) {
              browserOptions.defaultTracking = {
                pageViews: {
                  eventType: 'Page View'
                }
              };
            } else if (_typeof(pageViewTracking) === 'object' && pageViewTracking) {
              browserOptions.defaultTracking = {
                pageViews: {
                  trackOn: pageViewTracking.trackOn,
                  trackHistoryChanges: pageViewTracking.trackHistoryChanges,
                  eventType: pageViewTracking.eventType || 'Page View'
                }
              };
            }
            return [4 /*yield*/, client.init(options.apiKey, options.userId, browserOptions).promise];
          case 4:
            _a.sent();
            return [2 /*return*/];
        }
      });
    });
  };

  return __assign(__assign({}, client), {
    init: function init(apiKey, userId, options) {
      if (options === void 0) {
        options = {};
      }
      return returnWrapper(_init(__assign(__assign({}, options), {
        userId: userId,
        apiKey: apiKey
      })));
    }
  });
};
export default createInstance();